export type FieldErrorType = {
  [key: string]: string;
};

export const handleApiErrors = <T extends object>(
  err: any,
  setErrors: (errors: FieldErrorType) => void,
  triggerToast: (message: string, color: 'success' | 'danger') => void,
  fallbackMessage = 'Something went wrong. Please try again.'
) => {
  const raw = err?.data?.data?.error ?? err?.data?.error ?? err?.data;

  if (typeof raw === 'string') {
    return triggerToast(raw, 'danger');
  }

  if (raw && typeof raw === 'object') {
    const fieldErrors = Object.entries(raw).reduce((acc, [key, value]) => {
      if (Array.isArray(value) && typeof value[0] === 'string') {
        acc[key as string] = value[0];
      }
      return acc;
    }, {} as FieldErrorType);

    if (Object.keys(fieldErrors).length > 0) {
      return setErrors(fieldErrors);
    }
  }

  triggerToast(fallbackMessage, 'danger');
};
